import { render } from "./OrderProducts.vue?vue&type=template&id=0b37a1a1"
import script from "./OrderProducts.vue?vue&type=script&lang=js"
export * from "./OrderProducts.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__